import { useEffect, useRef, useState } from 'react';
import { getDetailedPathwayData } from './utils/Pathway';

export function usePathway(pathwayID) {
  const hasFetchedData = useRef(false);
  const [pathwayDetailData, setPathwayDetailData] = useState([]);
  const [pathwayDetailDataLoaded, setPathwayDetailDataLoaded] = useState(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getDetailedPathwayData(pathwayID, pathwayDetailDataCallback);
      hasFetchedData.current = true;
    }
  }, []);

  const pathwayDetailDataCallback = (data) => {
    setPathwayDetailData(data);
    setPathwayDetailDataLoaded(true);
  };

  return [pathwayDetailData as any, pathwayDetailDataLoaded];
}
